import axios, { AxiosRequestConfig } from 'axios';
import IResponse from '../interfaces/IResponse';
import { IModuleValuation } from '../interfaces/IModuleValuation';
import { IModule } from '../interfaces/IFurniture';
import { baseURL } from '../config';

const BASE_URL = `${baseURL}api/moduleValuation`;

interface ICreateModuleValuation extends IResponse {
    newValuation: IModuleValuation | null,
}

export interface ICreateModuleValuationDto {
    modules?: IModule[],
    standAloneModules?: IModule[],
    message?: string,
    furnitureId: string,
    furnitureName: string,
    furnitureImage: string,
    furnitureLink: string,
    email: string,
    phone: string,
}

const createModuleValuation = async (dto: ICreateModuleValuationDto): Promise<ICreateModuleValuation> => {
    const url = `${BASE_URL}`;
    const config: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    
    try {
        const res = await axios.post(url, dto, config);

        return {
            ok: true,
            status: res.status,
            message: 'Wycena modułów wysłana pomyślnie',
            newValuation: res.data.newValuation,
        };
    } catch (error) {
        let message = 'Nie utworzono wyceny modułów';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Nie można utworzyć wyceny modułów';
            if (error.response.status === 404) message = 'Nie znaleziono modułów do wyceny';
        }

        return {
            message,
            status,
            ok: false,
            newValuation: null,
        };
    }
};


interface IGetModuleValuationResponse extends IResponse {
    moduleValuation: IModuleValuation | null,
}


const getModuleValuation = async (valuationId: string): Promise<IGetModuleValuationResponse> => {
    const url = `${BASE_URL}/${valuationId}`;
    const config: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.get(url, config);
        return {
            ok: true,
            status: res.status,
            message: 'Pobrano wycenę modułów',
            moduleValuation: res.data,
        };
    } catch (error) {
        let message = 'Nie pobrano wyceny modułów';
        let status = 400;

        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 403) message = 'Brak uprawnień do pobrania wyceny modułów';
            if (error.response.status === 404) message = 'Nie znaleziono wyceny modułów';
        }

        return {
            message,
            status,
            ok: false,
            moduleValuation: null,
        };
    }
}


const moduleValuationController = {
    createModuleValuation,
    getModuleValuation,
}

export default moduleValuationController;